import { Modal } from "react-bootstrap";
import React from "react";
import { observer } from "mobx-react";
import { useStore } from "../../../../../contexts/store-provider";
import { formatMessage } from "../../../../../translations/format-message";

interface PreviewProps {
  onModalClosed: () => void;
  image: string;
}

const Preview: React.FC<PreviewProps> = (props: PreviewProps) => {
  const {smrStore} = useStore();
  const {medicalRecordImageDetail} = smrStore;

  return (
    <Modal show={true} centered>
      <Modal.Header>
        <Modal.Title>{formatMessage("preview")}</Modal.Title>
        <button onClick={props.onModalClosed} className="Crossicons">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="23"
            fill="currentColor"
            className="bi bi-x"
            viewBox="0 0 16 16"
          >
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
          </svg>
        </button>
      </Modal.Header>
      <Modal.Body>
        {
          props.image &&
          <div className="preview_image">
            <img src={props.image} alt="preview" />
          </div>
        }
      </Modal.Body>
    </Modal>
  );
};

export default observer(Preview);
